import {
    AGENT_INFO_GET,
} from '../actions/types';


import {
    AJAX_NOT_RUNNING,
} from '../services/config';

const initialState = {
    agentInfo: [],
};

export default function (state = initialState, action) {

    switch (action.type) {
        case AGENT_INFO_GET:
            return {
                ...state,
                agentInfo: action.payload
            };
        default:
            return state;
    }

}